<div class="prueba1">
  <div class="progreso-container">
    <div class="progreso-bar">
      <div 
        class="progreso-fill segment1" 
        [id]="item + '_1'" 
        [title]="'AUTORIZADO: ' + value1 + '%'">
        <b *ngIf="value1 > 0" class="value-label">{{value1}}</b>
        <b *ngIf="value1 > 15" class="value-label">%</b>
      </div>
      <div 
        class="progreso-fill segment2" 
        [id]="item + '_2'" 
        [title]="'CREADO: ' + value2 + '%'">
        <b *ngIf="value2 > 0" class="value-label">{{value2}}</b>
        <b *ngIf="value2 > 15" class="value-label">%</b>
      </div>
      <div 
        class="progreso-fill segment3" 
        [id]="item + '_3'" 
        [title]="'RECHAZADO: ' + value3 + '%'">
        <b *ngIf="value3 > 0" class="value-label">{{value3}}</b>
        <b *ngIf="value3 > 15" class="value-label">%</b>
      </div>
      <div 
        class="progreso-fill segment4" 
        [id]="item + '_4'" 
        [title]="'EN PROGRESO: ' + value4 + '%'">
        <b *ngIf="value4 > 0" class="value-label">{{value4}}</b>
        <b *ngIf="value4 > 15" class="value-label">%</b>
      </div>
      <div 
        class="progreso-fill segment5" 
        [id]="item + '_5'" 
        [title]="'CERRADO: ' + value5 + '%'">
        <b *ngIf="value5 > 0" class="value-label">{{value5}}</b>
        <b *ngIf="value5 > 15" class="value-label">%</b>
      </div>
    </div>
  </div>    
</div>

  